<template>
  <div>
    <h1 class="com-title com-ht">
      <i></i>签署设置
    </h1>
    <div class="box-card">
      <p>
        保全章：
        <el-switch
          v-model="settingsConfig.presFlag"
          :active-color="activeColor"
          :active-value="activeVal"
          :inactive-value="inactiveVal"
          @change="settingsChange($event,'presFlag')"
        ></el-switch>
      </p>
      <span>提示：开启时，合同第一页右上角会显示由君子签&易保全电子数据保全中心加盖的数据存证保全章，关闭则不显示。</span>
    </div>
    <div class="box-card">
      <p>
        企业骑缝章：
        <el-switch
          v-model="settingsConfig.qifengFlag"
          :active-color="activeColor"
          :active-value="activeVal"
          :inactive-value="inactiveVal"
          @change="settingsChange($event,'qifengFlag')"
        ></el-switch>
      </p>
      <span>提示：开启时，所有企业签署方在签署合同时会自动加盖骑缝章，关闭则不会加盖骑缝章。</span>
    </div>
    <div class="box-card">
      <p>
        个人骑缝章：
        <el-switch
          v-model="settingsConfig.perQifengFlag"
          :active-color="activeColor"
          :active-value="activeVal"
          :inactive-value="inactiveVal"
          @change="settingsChange($event,'perQifengFlag')"
        ></el-switch>
      </p>
      <span>提示：开启时，所有个人签署方在签署合同时会自动加盖骑缝章，关闭则不会加盖骑缝章。</span>
    </div>
    <div class="box-card">
      <p>
        个人图形章：
        <el-switch
          v-model="settingsConfig.perSealFlag"
          :active-color="activeColor"
          :active-value="activeVal"
          :inactive-value="inactiveVal"
          @change="settingsChange($event,'perSealFlag')"
        ></el-switch>
      </p>
      <span>提示：开启时，所有个人签署方在签署合同时，仅可使用图形章，关闭则可选择使用手写签字或图形章</span>
    </div>
    <div class="box-card">
      <p>
        签章时间：
        <el-switch
          v-model="settingsConfig.timeFlag"
          :active-color="activeColor"
          :active-value="activeVal"
          :inactive-value="inactiveVal"
          @change="settingsChange($event,'timeFlag')"
        ></el-switch>
      </p>
      <span>提示：开启时，所有签署方的签章左下角会展示合同签署日期，关闭则所有签署方的签章不显示签署时间。</span>
    </div>
    <div class="box-card">
      <p>
        文件水印：
        <el-switch
          v-model="settingsConfig.waterFlag"
          :active-color="activeColor"
          :active-value="activeVal"
          :inactive-value="inactiveVal"
          @change="settingsChange($event,'waterFlag')"
        ></el-switch>
        <!-- <template>
          <el-tag v-if="settingsConfig.waterFlag" size="small" color="#ec1c1c" style="color:#fff;">已开启</el-tag>
          <el-tag v-else size="small" type="info">已关闭</el-tag>
        </template>-->
        <el-button type="small" style="margin-left:10px" @click="waterVisi = true">设置</el-button>
      </p>
      <span>提示：开启时，设置好的水印会在合同发起后添加在所有已上传的签署文件中。</span>
    </div>
    <!-- 签署密码 -->
    <signPwd class="box-card"></signPwd>
    <div class="box-card">
      <p>
        数字证书：
        <el-switch
          v-model="settingsConfig.certFlag"
          :active-color="activeColor"
          :active-value="activeVal"
          :inactive-value="inactiveVal"
          @change="settingsChange($event,'certFlag')"
        ></el-switch>
      </p>
      <span>测试签约流程时，可关闭数字证书，正式签署时带数字证书可进一步保障签约有效性。</span>
    </div>
    <!-- 手写签字校验 -->
    <signCheck class="box-card" v-if="handleSignShowStatus"></signCheck>
    <!-- 弹窗组件 -->
    <!--  设置水印 setWatermarkVisible -->
    <el-dialog title="添加水印" width="60%" :visible.sync="waterVisi">
      <waterMark
        v-if="waterVisi"
        :visible.sync="waterVisi"
        :waterConfig.sync="settingsConfig.waterSetting"
        @settingWater="settingWater"
      />
    </el-dialog>
  </div>
</template>
<script>
// components
import signPwd from '../../../tpl/signPwd.vue'
import signCheck from '../../../tpl/signCheck.vue'
import waterMark from "../../../../components/waterMark/index.vue";
// API
import { ApiMethods } from "@/assets/js/http-serve/http-methods.js";
//
import { mapGetters } from 'vuex'
import Template from '../../template.vue';

export default {
  components: { signPwd, signCheck, waterMark, Template },
  data () {
    // 这里存放数据
    return {
      activeColor: "#ec1c1c",
      inactiveVal: 0,
      activeVal: 1,
      settingsConfig: {
        presFlag: 0,
        qifengFlag: 0,
        perQifengFlag: 0,
        timeFlag: 0,
        waterFlag: 0,
        perSealFlag: 0,
        waterSetting: {},
      },
      waterVisi: false,
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(['allAuthUser', 'currentAuthUser']),
    handleSignShowStatus () {
      //手写签字的权限 + API当前列表是否存在
      const { accountInfoVO } = this.allAuthUser;
      // const have = accountInfoVO && accountInfoVO.handSealCheckScore && this.currentAuthUser && this.currentAuthUser.merchantFlag === 1
      const have = accountInfoVO && accountInfoVO.handSealCheckScore;
      return have
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    /** 设置水印 */
    settingWater ({ val, key }) {
      console.log('switch', val, key);
      this.settingsConfig.waterFlag = val
      this.settingsChange(val, key)
    },
    /** 开关change */
    settingsChange (val, key) {
      if (key === 'waterFlag' && Object.keys(this.settingsConfig.waterSetting).length <= 1) {
        this.settingsConfig[key] = Number(!val)
        return this.$message.warning('请先设置水印')
      } else if (key === 'certFlag' && !val) {
        this.settingsConfig[key] = Number(!val)
        this.$confirm(`<p style="font-size: 16px; font-weight: bold">确定关闭数字证书？</p><p style="font-size: 14px;">签署时带数字证书可进一步保障签约有效性。</p>`, "提示", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.settingsConfig[key] = Number(val)
          this.saveSettings({ key, val })
        }).catch()
      } else {
        this.saveSettings({ key, val })
      }
    },
    // 保存设置
    saveSettings ({ key, val }) {
      this.loadingStart()
      const params = { ...this.settingsConfig }
      if (params.waterSetting && params.waterSetting.floatAlpha > 1) params.waterSetting.floatAlpha = params.waterSetting.floatAlpha / 100
      params.waterSetting = JSON.stringify(params.waterSetting)
      ApiMethods.PreferenceSettingsAPI.setPreferences(params).then(res => {
        if (!res.success) {
          this.settingsConfig[key] = Number(!val)
          return this.$message.error(res.description)
        };
        this.$message.success(val == 1 ? '开启成功' : '关闭成功')
      }).finally(() => { this.loadingClose() })
    },
    /** 查询偏好设置 */
    getSettings () {
      this.loadingStart()
      ApiMethods.PreferenceSettingsAPI.getPreferences().then(res => {
        if (!res.success) return this.$message.error(res.description);
        if (res.data) this.settingsConfig = Object.assign(this.settingsConfig, JSON.parse(JSON.stringify(res.data)));
        const waterSet = JSON.parse(res.data.waterSetting) || ''
        if (Object.prototype.toString.call(waterSet) === '[object Object]') {
          waterSet.floatAlpha = waterSet.floatAlpha * 100
          this.settingsConfig.waterSetting = waterSet
        } else {
          this.settingsConfig.waterSetting = {}
        }
      }).finally(() => { this.loadingClose() })
    },
    loadingStart (info = null) {
      this.loadingClose();
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    loadingClose () {
      if (this.loading) {
        this.loading.close();
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getSettings()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { },
}
</script>

<style lang='less' scoped>
// @import url(); 引入公共css类
.box-card {
  width: 98%;
  margin: 2vh auto;
  padding: 1vh;
  border-radius: 6px;
  box-shadow: 0 1px 4px 1px #9f9c9c;
  > p {
    font-size: 0.85vw;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// pages/console/accountPage/components/signSettings.vue